module.exports = __webpack_public_path__ + "static/media/cacao-carry.942a2aa9.jpg";